"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestContext = void 0;
// implementation only intended for use with Lambda functions which are single-threaded
// and processes a single request with each invocation (sequential)
// Not to be be used on backend servers running NodeJS which requires use of AsyncLocalStorage
class RequestContext {
    static initialize() {
        this.context.clear();
    }
    static store() {
        return this.context;
    }
}
exports.RequestContext = RequestContext;
RequestContext.context = new Map();
//# sourceMappingURL=RequestContext.js.map